import type { RouteLocationNormalized, RouteLocationRaw, RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";

import type { KonfessionenDatenProps } from "~/components/schule/kataloge/konfessionen/daten/KonfessionenDatenProps";
import { type RouteKonfessionen, routeKonfessionen } from "~/router/apps/schule/kataloge/konfessionen/RouteKonfessionen";
import { RouteNode } from "~/router/RouteNode";

const KonfessionenDaten = () => import("~/components/schule/kataloge/konfessionen/daten/KonfessionenDaten.vue");

export class RouteKonfessionenDaten extends RouteNode<any, RouteKonfessionen> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.KATALOG_EINTRAEGE_ANSEHEN, BenutzerKompetenz.KATALOG_EINTRAEGE_AENDERN], "schule.konfessionen.daten",
			"daten", KonfessionenDaten);
		super.mode = ServerMode.STABLE;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Konfessionen";
	}

	public async update(to: RouteNode<any, any>, to_params: RouteParams): Promise<void | Error | RouteLocationRaw> {
		if (routeKonfessionen.data.manager.auswahlID() === null) {
			return routeKonfessionen.getRoute();
		}
	}

	public getProps(to: RouteLocationNormalized): KonfessionenDatenProps {
		return {
			manager: () => routeKonfessionen.data.manager,
			patch: routeKonfessionen.data.patch,
		};
	}

}

export const routeKonfessionenDaten = new RouteKonfessionenDaten();

